module.exports = __webpack_public_path__ + "img/d20190921_2.9b075304.jpg";